import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_get_footprint_attachment_content_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { entityType: string, attachmentId: number }): Promise<{ fileContent?: Blob }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityType)) {
      missingRequiredInParams.push('\'entityType\'');
    }
    if (isNil(inParams.attachmentId)) {
      missingRequiredInParams.push('\'attachmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/functions/get_footprint_attachment_content_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    const blobOptions: any = {
      ...options,
      observe: 'response',
      responseType: 'blob'
    };
    const response = await this.$utils.http.post<HttpResponse<Blob>>(url, body, blobOptions);
    const blobParamValue = response.status === 200 ? this.$utils.http.httpClientResponseToBlob(response) : null;
    return { fileContent: blobParamValue };
    
  }

}

